import './check-in-request.modal.scss';

export default function CheckInRequestModal($scope, request, close) {
  'ngInject';

  $scope.checkIn = {
    request: request,
    date: new Date()
  };

  $scope.ok = () => {
    close(true);
  };

  $scope.close = () => {
    close();
  };

}